var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"outlined":_vm.variant == 'outlined',"depressed":!_vm.variant || _vm.variant == 'default',"text":_vm.variant == 'text',"color":_vm.color ? _vm.color : 'primary',"dark":"","icon":_vm.variant == 'icon'},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }